import type { RecipientOption } from '@/services/domain/messages/types'

export const serviceDistributionStepVariant = ['recipients', 'additionalSettings', 'finishUp'] as const
export type ServiceDistributionStep = (typeof serviceDistributionStepVariant)[number]

export type ServiceDistributionRecipientsFormSchema = {
  name: string
  recipients: RecipientOption[]
}

export type ServiceDistributionIncludeOptions = 'both' | 'body' | 'subject'

export enum DistributionStatus {
  Active = 'active',
  Paused = 'paused',
}

export type ServiceDistributionAdditionalSettingsFormSchema = {
  includeOptions: ServiceDistributionIncludeOptions
  maxLength: string
  sender: string
  sourceType?: string | null
  onlyAllowedSenders: boolean
}

export type DistributionDetailsPayload = {
  name: string
  recipients: { contactIds: number[]; segmentIds: number[]; groupIds: number[]; folderIds: number[]; numbers: string[] }
} & ServiceDistributionAdditionalSettingsFormSchema

export type DistributionDetailsResponse = {
  id: string
  name: string
  email: string
  membersCount: number
}

export type ServiceDistributionSharedData = Partial<{ id: string; email: string } & DistributionDetailsPayload>
